import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/common/app';
import Component from 'flarum/common/Component';
import LoadingIndicator from 'flarum/common/components/LoadingIndicator';
import Button from 'flarum/common/components/Button';
import Icon from 'flarum/common/components/Icon';
import mimeToIcon from '../mimeToIcon';
import ItemList from 'flarum/common/utils/ItemList';
import Tooltip from 'flarum/common/components/Tooltip';
import extractText from 'flarum/common/utils/extractText';
export default class DisplayFile extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "isFileHiding", void 0);
    _defineProperty(this, "imageLoaded", true);
    _defineProperty(this, "file", void 0);
    _defineProperty(this, "fileIcon", void 0);
    _defineProperty(this, "isSelected", void 0);
    _defineProperty(this, "isSelectable", void 0);
    // Function to call when image fails to load
    _defineProperty(this, "handleImageError", () => {
      this.imageLoaded = false;
      this.fileIcon = 'fas fa-exclamation-triangle';
      this.isSelectable = false;
      m.redraw();
    });
    // Function to call when image loads successfully
    _defineProperty(this, "handleImageLoad", () => {
      this.imageLoaded = true;
      m.redraw();
    });
  }
  oninit(vnode) {
    super.oninit(vnode);
    this.file = this.attrs.file;
    this.isFileHiding = this.attrs.isFileHiding === undefined ? false : this.attrs.isFileHiding;
    this.fileIcon = mimeToIcon(this.file.type());
    this.isSelected = this.attrs.isSelected === undefined ? false : this.attrs.isSelected;
    this.isSelectable = this.attrs.fileSelectable === undefined ? true : this.attrs.fileSelectable;
  }
  onbeforeupdate(vnode) {
    super.onbeforeupdate(vnode);

    // Make sure the isSelected property is updated
    this.isSelected = this.attrs.isSelected === undefined ? false : this.attrs.isSelected;
  }
  view() {
    const isImage = this.file.type().startsWith('image/');
    const fileSelectedClass = this.isSelected ? 'selected' : '';
    return m("div", {
      className: "UploadedFile ".concat(fileSelectedClass),
      key: this.file.uuid(),
      onclick: () => {
        if (this.isSelectable && !this.isFileHiding) {
          this.isSelected = !this.isSelected;
          this.attrs.onFileClick(this.file);
        }
      },
      disabled: !this.isSelectable || this.isFileHiding
    }, this.imageLoaded && isImage ? m("img", {
      src: this.file.url(),
      className: "fof-file-image-preview",
      draggable: false,
      onerror: this.handleImageError,
      onload: this.handleImageLoad,
      alt: this.file.baseName()
    }) : this.displayIcon(this.fileIcon), m("div", {
      className: "fof-file-actions"
    }, this.actionItems(this.file).toArray()), m("div", {
      className: "fof-file-name"
    }, m(Tooltip, {
      text: this.file.baseName()
    }, m("span", null, this.file.baseName()))), this.isFileHiding && m("div", {
      class: "fof-file-loading",
      role: "status",
      "aria-label": app.translator.trans('fof-upload.lib.file_list.hide_file.loading')
    }, m(LoadingIndicator, null)));
  }
  displayIcon(fileIcon) {
    return m("span", {
      className: "fof-file-icon",
      role: "presentation",
      style: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%' // Ensure the container takes up the necessary space
      }
    }, m(Icon, {
      name: "fa-fw ".concat(fileIcon)
    }));
  }
  actionItems(file) {
    const items = new ItemList();
    file.canViewInfo() && items.add('view-info', m(Button, {
      className: "Button Button--icon fof-file-action",
      icon: "fas fa-info-circle",
      "aria-label": "info",
      onclick: () => this.viewFileInfo()
    }), 100);
    const transPrefix = file.isShared() ? 'fof-upload.lib.file_list.hide_shared_file' : 'fof-upload.lib.file_list.hide_file';
    const hideTranslation = app.translator.trans(this.file.hidden() ? "".concat(transPrefix, ".btn_a11y_label_show") : "".concat(transPrefix, ".btn_a11y_label_hide"), {
      fileName: file.baseName()
    });
    file.canHide() && items.add('hide-file', m(Tooltip, {
      text: hideTranslation,
      position: "bottom"
    }, m(Button, {
      className: "Button Button--icon fof-file-action",
      icon: this.file.hidden() ? 'fas fa-eye' : 'fas fa-eye-slash',
      "aria-label": hideTranslation,
      disabled: this.isFileHiding,
      onclick: e => this.hide(e)
    })), 80);
    const deleteTranslation = app.translator.trans('fof-upload.lib.file_list.delete_file_a11y_label', {
      fileName: file.baseName()
    });
    file.canDelete() && items.add('delete-file', m(Tooltip, {
      text: deleteTranslation,
      position: "bottom"
    }, m(Button, {
      className: "Button Button--icon fof-file-action",
      icon: "fas fa-trash",
      "aria-label": deleteTranslation,
      disabled: this.isFileHiding,
      onclick: e => this.confirmDelete(e)
    })), 60);
    return items;
  }
  viewFileInfo() {
    console.log('view file info');
  }
  hide(e) {
    e.stopPropagation();

    // TODO: local logic, then:

    if (this.attrs.onHide) {
      this.attrs.onHide(this.file);
    }
  }
  async confirmDelete(e) {
    e.stopPropagation();
    if (confirm(extractText(app.translator.trans('fof-upload.lib.file_list.delete_confirmation', {
      fileName: this.file.baseName()
    })))) {
      const uuid = this.file.uuid();
      await app.request({
        method: 'DELETE',
        url: app.forum.attribute('apiUrl') + '/fof/upload/delete/' + uuid
      });
      if (this.attrs.onDelete) {
        this.attrs.onDelete(this.file);
      }
    }
  }
}
flarum.reg.add('fof-upload', 'common/components/DisplayFile', DisplayFile);